import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./ChangePasswordProveedorLealtad.css";

const ChangePasswordLealtad = ({ data }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const id = data.id;

  const handleCurrentPasswordChange = (event) => {
    setCurrentPassword(event.target.value);
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleChangePass = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_CHANGE_PASSWORD_PROVEEDOR_LEALTAD}`,
        {
          currentPassword,
          newPassword,
          id,
        }
      );

      Swal.fire({
        icon: "success",
        title: "Contraseña actualizada",
        text:
          "Tu contraseña ha sido actualizada correctamente." ||
          res.data.message,
      });
      setNewPassword("");
      setCurrentPassword("");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un error al intentar cambiar la contraseña. Por favor, inténtalo de nuevo más tarde.",
      });
    }
  };

  return (
    <div className="boxpasswordlealtad">
      <div className="dosplayinputProvprofilelealtad">
        <div className="boxinputprovprofilelealtad">
          <label className="labelformprovprofilelealtad">Contraseña actual</label>
          <input
            className="inputupdateProvprofilelealtad"
            type="password"
            value={currentPassword}
            onChange={handleCurrentPasswordChange}
            required
          />
        </div>
        <div className="boxinputprovprofilelealtad">
          <label className="labelformprovprofilelealtad">Contraseña nueva</label>
          <input
            className="inputupdateProvprofilelealtad"
            type="password"
            value={newPassword}
            onChange={handleNewPasswordChange}
            required
          />
        </div>
      </div>
      <div className="boxprovbuttonprfile2lealtad">
        <button
          type="submit"
          className="buttonprovprofilelealtad"
          onClick={handleChangePass}
        >
          Cambiar contraseña
        </button>
      </div>
    </div>
  );
};

export default ChangePasswordLealtad;
